const eventName = 'profenz:authorized-workspace-refresh';

/** Called only after the server confirms login or an authorized context switch. */
export function refreshAuthorizedWorkspace(destination?: string): boolean {
  return !window.dispatchEvent(new CustomEvent(eventName, {cancelable: true, detail: destination}));
}

/** Replace the entire React tree: never retain data or pending callbacks from the old context. */
export function installWorkspaceNavigation(renderFresh: (path: string) => void): () => void {
  const change = (event: Event) => {
    const destination: unknown = (event as CustomEvent).detail;
    if (destination !== undefined && destination !== null) {
      if (typeof destination !== 'string') return;
      let url: URL;
      try {url = new URL(destination, window.location.href);} catch {return;}
      if (url.origin !== window.location.origin || !['/', '/fenzsafe', '/mfa'].includes(url.pathname)) return;
      window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    }
    event.preventDefault();
    renderFresh(window.location.pathname);
  };
  window.addEventListener(eventName, change);
  return () => window.removeEventListener(eventName, change);
}
